import moment from 'moment';

const clientInfo = (client) => {
  const info = [];
  const city = client.city ? client.city : "";
  const province = client.province ? client.province : "";
  const country = client.country ? client.country : "";

  info.push({ text: "Billed To", style: "infoHeaderText" });
  info.push({ text: client.fullName ? client.fullName : "" });
  client.address && info.push({ text: client.address });
  client.city && info.push({ text: `${city} ${province} ${country}` });
  client.postalCode && info.push({ text: client.postalCode });

  return info;
};

export const invoiceInfo = (invoice, client) =>
({
  style: "invoiceInfo",
  layout: "noBorders",
  table: {
    widths:["auto", "auto", "*", "auto"],
    heights: 120,
    body: [[
            {
                style: "billToColumn",
                stack: clientInfo(client)
            },

            {
                style: "invoiceNumberColumn",
                stack: [

                    { text: "Date of Issue", style: "infoHeaderText" },
                    { text: moment(invoice.invoiceDate).format("MM/DD/YYYY") },
                    { text: "Due Date", style: "infoSubheaderText" },
                    { text: moment(invoice.dueDate).format("MM/DD/YYYY") }
                ]
            },
            { text: "" },
            {
                style: "invoiceTotalColumn",
                stack: [
                    { text: "Invoice Number", style: "infoHeaderText" },
                    { text: invoice.invoiceNumber },
                    { text: "Invoice Total", style: "infoSubheaderText" },
                    { text: `$${Number(invoice.grandTotal).toFixed(2)}` }
                ]
            }
    ]]
  }
});



// WEBPACK FOOTER //
// ./src/store/generators/PDF/invoice/invoiceInfo.js